import React from 'react';
import PropTypes from 'prop-types';
import { RESOURCE_GROUP_TYPES, RESOURCE_ALERT_LEVEL } from 'APP_ROOT/components/pages/dashboard/ResourceGroups/constants';
import ResizeThrottler from 'APP_ROOT/components/ResizeThrottler';
import { strings } from 'APP_ROOT/localization';
import ProgressOverlay from '../../../common/ProgressOverlay';
import TagsTreeViewDropDown from '../../../TagsTreeViewDropDown';
import CheckBox from '../../../common/CheckBox';
import ProgressSpinnerSmall from '../../../common/ProgressSpinnerSmall';


const LEGACY_FONT_SIZE = 16;
const BASE_FONT_SIZE = 14;
const DASHBOARD_RESOURCE_GROUP_HEADER_HEIGHT = 50 * (BASE_FONT_SIZE/LEGACY_FONT_SIZE); /* corresponds to $dashboard-resource-group-header-height in _dashboard.scss*/
const DASHBOARD_RESOURCE_GROUP_HEADER_EXTENDED_HEIGHT = 74 * (BASE_FONT_SIZE/LEGACY_FONT_SIZE); /* corresponds to $dashboard-resource-group-header-extended-height in _dashboard.scss*/
const DASHBOARD_RESOURCE_GROUP_FOOTER_HEIGHT = 35 * (BASE_FONT_SIZE/LEGACY_FONT_SIZE); /* corresponds to $dashboard-resource-group-footer-height in _dashboard.scss*/
const DASHBOARD_RESOURCE_ITEM_HEIGHT = 40 * (BASE_FONT_SIZE/LEGACY_FONT_SIZE); /* corresponds to $dashboard-resource-group-resource-height */
const DASHBOARD_RESOURCE_GROUP_RESOURCES_BOTTOM_PADDING = 12 * (BASE_FONT_SIZE/LEGACY_FONT_SIZE); /* corresponds to $dashboard-resource-group-resources-bottom-padding */
const WARNING_BADGE_UPDATE_INTERVAL = 250; /* update the badge count every 1/2 second while scrolling */
const SCROLL_MONITOR_TIMEOUT = 2000;

const SEARCH_FILTER_INPUT_VALUE_APPLY_INTERVAL = 1000; /// auto-apply every 3 seconds
export default class ResourceGroup extends React.PureComponent {

    highestAlertLevelForGroup = RESOURCE_ALERT_LEVEL.DEFAULT;
    groupListRef = React.createRef();
    groupListItemsComponents = [];
    showNoResourcesMessage = false;
    
    preFilteredResourcesVisibilityById = {}; // {resourceId: visible} store which is used to restore resource visibility state when a search filter is cleared

    state = {
        totalWarningItems: 0,
        totalTopHiddenWarningItems: 0,
        totalBottomHiddenWarningItems: 0,
        searchFilterInputValue: "",
        searchFilterInputValueShowNoResultsMessage: false,
        searchFilterSelectedOptionFilteredItemsIds: null,
        filterByTagsSelectedOptions: [], // List of selected tags to filter list by
        setAllVisible: true,
        currentBadgesView: 'status',
    }
    searchFilterInputValueApplyThrottledStateValue = undefined;
    searchFilterInputValueApplyDate = new Date();
    searchFilterInputValueApplyThrottledTimeoutId;

    filterByTagsSelectedOptionsStateValue = [] // List of selected tags to filter list by

    scrollMonitorIntervalID;
    scrollMonitorIntervalTimeoutID;

    getResourceAlertLevel (resource) { // https://docs.google.com/spreadsheets/d/1vWQjISHrbDnlBqyO1j-ElYQHJMjcdBiuEssstusrAwU


        let alertLevel = RESOURCE_ALERT_LEVEL.DEFAULT;

        if (this.props.type !== RESOURCE_GROUP_TYPES.VEHICLE) {
            return alertLevel;
        }

        // check in order of highest to lowest to bail early, if possible

        // up to severe - EVENT_POSSIBLE_IMPACT, EVENT_SPEEDING_STARTED (% over), EVENT_IDLING_STARTED (by duration), EVENT_RAVEN_BAD_INSTALL_DETECTED:
        if (!resource.dashboard || !resource.dashboard.events) { // currently, only dashboard events are supported/checked
            return alertLevel;
        }

        /* DISABLED (only SEVERE alert level currently supported)
        const offline = resource.vehicleState ? resource.vehicleState.ravenOffline : false;
        if (resource.unplugged || offline) { // Proerty set in sessionManager.getRavenDashboardSuccess / mqttService.onMQTTEvent in realtime
            alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
        }

        const shutdownByUser = RavenUtil.isShutdownByUser(resource.dashboard) ? true : false; // collapsing nulls and falses to false
        if (shutdownByUser) {
            alertLevel = RESOURCE_ALERT_LEVEL.CRITICAL;
        }

        if (resource.isIdling) { // Proerty set in sessionManager.getRavenDashboardSuccess / mqttService.onMQTTEvent in realtime
            alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
        }*/


        const events = resource.dashboard ? resource.dashboard.events : undefined;
        if (events) {
            var warningEvents = events.filter((event) => {
                return document.filterEventTypeAllowedForWarningContext(event.type);
            });
            warningEvents.forEach((event, index) => {

                if (alertLevel === RESOURCE_ALERT_LEVEL.SEVERE) { // check if highest level found earlier in this forEach
                    return; // this could be avoided with a basic for loop but warningEvents is probably very short
                }

                const mostRecentCoupleEvents = events.length > 2 ? 2 : events.length;
                let i = 0;

                switch (event.type) {
                    case "EVENT_POSSIBLE_IMPACT": // SEVERE
                    case "EVENT_RAVEN_BAD_INSTALL_DETECTED":
                        alertLevel = RESOURCE_ALERT_LEVEL.SEVERE;
                        return;
                    /*
                    case "EVENT_SPEEDING_STARTED":
                        // if currently speeding, calc percentage over limit
                        // >= 50% = severe
                        alertLevel = RESOURCE_ALERT_LEVEL.SEVERE;
                        // >= 25% = critical:
                        // already checked at beginning of this function: if (alertLevel !== RESOURCE_ALERT_LEVEL.SEVERE) {
                            alertLevel = RESOURCE_ALERT_LEVEL.CRITICAL;
                        //}
                        // >= 15% over limit:
                        if (alertLevel !== RESOURCE_ALERT_LEVEL.CRITICAL) { // assuming already checked if severe at beginning of this func
                            alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
                        }
                        return;
                    case "EVENT_IDLING_STARTED":
                        // if currently idling, check duration
                        // >= 25 mins = severe
                        alertLevel = RESOURCE_ALERT_LEVEL.SEVERE;
                        // >= 20 mins = critical:
                        // already checked at beginning of this function: if (alertLevel !== RESOURCE_ALERT_LEVEL.SEVERE) {
                            alertLevel = RESOURCE_ALERT_LEVEL.CRITICAL;
                        //}
                        // >= 10 mins:
                        if (alertLevel !== RESOURCE_ALERT_LEVEL.CRITICAL) { // assuming already checked if severe at beginning of this func
                            alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
                        }
                        return;
                    */
                    default:
                       return;
                }
            });
        }

        return alertLevel;

        /* DISABLED (only SEVERE alert level currently supported)
        if (alertLevel === RESOURCE_ALERT_LEVEL.SEVERE) {
            return alertLevel; // return highest level (severe)
        }

        // up to severe - DTCs
        if (resource.vehicle && resource.vehicle.activeDTCs) {

            resource.vehicle.activeDTCs.forEach((dtc, index) => {

                if (alertLevel === RESOURCE_ALERT_LEVEL.SEVERE) { // check if highest level found earlier in this forEach
                    return; // this could be avoided with a basic for loop but warningEvents is probably very short
                }
                switch (dtc.severity) {
                    case "SEVERITY_HIGH":
                        alertLevel = RESOURCE_ALERT_LEVEL.SEVERE;
                        return;
                    case "SEVERITY_MEDIUM":
                        // assumption: alertLevel SEVERE already checked
                        alertLevel = RESOURCE_ALERT_LEVEL.CRITICAL;
                        return;
                    case "SEVERITY_LOW":
                        // assumption: alertLevel SEVERE already checked
                        if (alertLevel !== RESOURCE_ALERT_LEVEL.CRITICAL) {
                            alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
                        }
                        return;
                    default:
                        console.warn("ResourceGroup getResourceAlertLevel unknown DTC severity.");
                        // assumption: alertLevel SEVERE already checked
                        if (alertLevel !== RESOURCE_ALERT_LEVEL.CRITICAL) {
                            alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
                        }
                        return;
                }    

            });
        }


        if (alertLevel === RESOURCE_ALERT_LEVEL.CRITICAL) {
            return alertLevel; // return second-highest level (critical) already found
        }

        // up to critical - SD Card Errors
        switch (resource.sdCardStatus) {
            case "INSERTED":
            case "UNKNOWN":
                break;
            case "REMOVED":
                alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
                break;
            default: // only errors are left as default in this switch:
                alertLevel = RESOURCE_ALERT_LEVEL.CRITICAL;
                break;
        }

        if (alertLevel !== RESOURCE_ALERT_LEVEL.DEFAULT) {
            return alertLevel; // return second-highest level (critical) already found
        }

        // up to warning - Driver detected
        if (resource.isDriving) {
            const facialRecognitionEnabled = this.props.features && this.props.features.facial_recognition;

            if (facialRecognitionEnabled) {
                if (resource.vehicle) {
                    if (!resource.vehicle.currentDriver) {
                        alertLevel = RESOURCE_ALERT_LEVEL.WARNING;
                    }
                }
            }
        }

        return alertLevel;
        */
    }

    /*
      Preps all itemm components, assigned alert level props for each:
        * updates groupListItemsComponents using itemFactory
        * udpates highestAlertLevelForGroup if any item has alert level
      groupListItemsComponents is then reviewed in componentDidUpdate to light up badge
        if some alertlevel items are scrolled out of view
    */
    prepareGroupWarningAndItemElementsArray (items, itemProps, itemFactory) {

        function intForResourceAlertLevel (alertLevel) {
            switch (alertLevel) {
                case RESOURCE_ALERT_LEVEL.DEFAULT:
                    return 0;
                case RESOURCE_ALERT_LEVEL.INFORMATIONAL:
                    return 1;
                case RESOURCE_ALERT_LEVEL.NOTIFICATION:
                    return 2;
                case RESOURCE_ALERT_LEVEL.WARNING:
                    return 3;
                case RESOURCE_ALERT_LEVEL.CRITICAL:
                    return 4;
                case RESOURCE_ALERT_LEVEL.SEVERE:
                    return 5;
                default:
                    console.warn("ResourceGroup prepareGroupWarningAndItemElementsArray intForResourceAlertLevel unknown alert level");
                    return 0; // return DEFAULT equivalent
            }
        }

        if (!items) {
            return null;
        }

        this.showNoResourcesMessage = !this.props.loading && items.length === 0 && !this.props.listErrorMessage;

        this.highestAlertLevelForGroup = RESOURCE_ALERT_LEVEL.DEFAULT;
        this.groupListItemsComponents = items.map(item => {

            let props = itemProps;
            props.warningLevel = this.getResourceAlertLevel(item);

            if (props.warningLevel !== RESOURCE_ALERT_LEVEL.DEFAULT) {
                if (intForResourceAlertLevel(this.highestAlertLevelForGroup) < intForResourceAlertLevel(props.warningLevel)) {
                    this.highestAlertLevelForGroup = props.warningLevel;
                }
            }
            return itemFactory(
                item,
                {
                    ...props,
                    badgesView: this.state.currentBadgesView,
                    onSelectResource: this.onSelectResource, // a function to capture item clicks and their current visibility and then call this.props.onSelectResource
                    onError: this.setItemErrorMessage
                }
            );
        });
    }

    setItemErrorMessage = (message) => {
        // Set the error message for the specific item
        this.setState({itemErrorMessage: message});
    }

    setWarningBadgesStateForRenderedElements = () => { // using arrow function to preserve scope for "this"

        if (this.props.type !== RESOURCE_GROUP_TYPES.VEHICLE) {
            return;
        }

        if (!this.groupListRef || !this.groupListRef.current) {
            // assumption: panel is not visible
            return;
        }
        const listTotalVisibleHeight = this.groupListRef.current.clientHeight; // current height TODO not accounting for padding (not accurate with Geofences bottom padding for 'add new geofence')
        /*
        commented-out because this can be really tricky to get right (failed some tests)
        const listTotalHeight = DASHBOARD_RESOURCE_ITEM_HEIGHT * this.groupListItemsComponents.length;
        if (listTotalHeight <= listTotalVisibleHeight) {
            return;
        }*/

        const listTopHiddenThreshold = this.groupListRef.current.scrollTop;
        const listBottomHiddenThreshold = listTotalVisibleHeight + listTopHiddenThreshold;
        let currentItemTopEdgeOffset = 0; // increased in DASHBOARD_RESOURCE_ITEM_HEIGHT increments 
        let currentItemBottomEdgeOffset = 0;
        let totalTopHiddenWarningItems = 0;
        let totalBottomHiddenWarningItems = 0;
        let totalWarningItems = 0; // used for collapsed panel badge
        this.groupListItemsComponents.forEach((component, index) => {

            if (component.props.warningLevel === RESOURCE_ALERT_LEVEL.DEFAULT) return; // only care about hidden active warning items

            totalWarningItems += 1;

            currentItemTopEdgeOffset = index * DASHBOARD_RESOURCE_ITEM_HEIGHT + (0.5 * DASHBOARD_RESOURCE_ITEM_HEIGHT);
            if (currentItemTopEdgeOffset < listTopHiddenThreshold) {
                totalTopHiddenWarningItems += 1;
            }
            currentItemBottomEdgeOffset = index * DASHBOARD_RESOURCE_ITEM_HEIGHT - (0.5 * DASHBOARD_RESOURCE_ITEM_HEIGHT);
            if (currentItemBottomEdgeOffset + DASHBOARD_RESOURCE_ITEM_HEIGHT > listBottomHiddenThreshold) {
                totalBottomHiddenWarningItems += 1;
            }
        });

        this.setState({
            totalWarningItems: totalWarningItems,
            totalTopHiddenWarningItems: totalTopHiddenWarningItems,
            totalBottomHiddenWarningItems: totalBottomHiddenWarningItems
        });
    }

    resourceGroupSectionHeight () {
        const { items, tags, footerHeight } = this.props;
        const totalDevices = items.length;
        let combinedHeight = DASHBOARD_RESOURCE_GROUP_HEADER_HEIGHT; // there is a search filter 

        // Currently, only vehicles have tags filter
        if(tags && this.props.type === RESOURCE_GROUP_TYPES.VEHICLE){
            combinedHeight += DASHBOARD_RESOURCE_GROUP_HEADER_HEIGHT; // tags filter header

            combinedHeight += DASHBOARD_RESOURCE_GROUP_HEADER_EXTENDED_HEIGHT; // controls (including Show/Hide All + Tags/Status badges view) which need a bit more vertical space
        }
        // Geofences, assets and ...
        else {
            combinedHeight += DASHBOARD_RESOURCE_GROUP_HEADER_HEIGHT; // controls (including just Show/Hide All) normal height
        }

        combinedHeight += totalDevices * DASHBOARD_RESOURCE_ITEM_HEIGHT;

        if(this.props.listErrorMessage || this.state.itemErrorMessage){
            combinedHeight += DASHBOARD_RESOURCE_ITEM_HEIGHT;
        }

        combinedHeight += DASHBOARD_RESOURCE_GROUP_FOOTER_HEIGHT;
        combinedHeight += DASHBOARD_RESOURCE_GROUP_RESOURCES_BOTTOM_PADDING;
        if (footerHeight) combinedHeight += footerHeight;
        return combinedHeight;
    }

    /*
      Checks the rendered items list components' 'warningActive' props
      Throttling to avoid multiple re-renders per second while scrolling
    */
    onListScroll = () => { // using arrow function to preserve scope for "this"

        // check if update is already pending
        if (this.scrollMonitorIntervalTimeoutID) {

            //clearTimeout(this.scrollMonitorIntervalTimeoutID);
            return;
            // pending request cleared, to be replaced by new pending request below
        } else {

            this.setWarningBadgesStateForRenderedElements();
            this.scrollMonitorIntervalID = setInterval(
                this.setWarningBadgesStateForRenderedElements,
                WARNING_BADGE_UPDATE_INTERVAL
            );

            this.scrollMonitorIntervalTimeoutID = setTimeout(
                () => { // using arrow function to preserve scope for "this"
                    clearInterval(this.scrollMonitorIntervalID);
                    this.scrollMonitorIntervalTimeoutID = undefined; // clear the interval id
                },
                SCROLL_MONITOR_TIMEOUT
            );
        }
    }

    componentDidMount() {
        window.addEventListener("scroll", this.onListScroll, { passive: true }); // bind onListScroll, resolves "this" undefined

        switch (this.props.type) {

            case RESOURCE_GROUP_TYPES.VEHICLE:
                if (this.props.ravensSearchFilterOption) {

                    const {searchFilterSelectedOption, filterByTagsSelectedOptions} = this.props.ravensSearchFilterOption;

                    // Settibg the search filter from props
                    const labelAndValue = searchFilterSelectedOption.value || searchFilterSelectedOption.label;

                    this.searchFilterInputValueApplyThrottledStateValue = labelAndValue;

                    
                    if (labelAndValue) {
                        // restore input box state for search filter
                        this.setState({
                            searchFilterInputValue: labelAndValue
                        });
                    } else {
                        console.error("ResourceGroup componentDidMount invalid ravensSearchFilterOption prop format", searchFilterSelectedOption);
                    }
                    
                    
                    // Setting the tags filter from props
                    const tagsIds = filterByTagsSelectedOptions;
                    
                    if(Array.isArray(tagsIds)){
                        this.filterByTagsSelectedOptionsStateValue = tagsIds;
                        this.setFilterByTagsOptions();
                    }
                    else{
                        console.error("ResourceGroup componentDidMount invalid filterByTagsSelectedOptions prop format", filterByTagsSelectedOptions);
                    }
                    
                    this.preFilteredResourcesVisibilityById = this.props.preFilteredRavensVisibilityById;

                    this.setSearchFilterSelectedOptionFilteredItemsIdsFor(searchFilterSelectedOption, filterByTagsSelectedOptions);
                }
                break;
            
            case RESOURCE_GROUP_TYPES.GEOFENCE:

                if (this.props.geofencesSearchFilterOption) {
                    const {searchFilterSelectedOption} = this.props.geofencesSearchFilterOption;

                    const labelAndValue = searchFilterSelectedOption.value || searchFilterSelectedOption.label;

                    this.searchFilterInputValueApplyThrottledStateValue = labelAndValue;

                    this.preFilteredResourcesVisibilityById = this.props.preFilteredGeofencessVisibilityById;

                    if (labelAndValue) {
                        // restore input box state for search filter
                        this.setState({
                            searchFilterInputValue: labelAndValue
                        });
                    } else {
                        console.error("ResourceGroup componentDidMount invalid geofencesSearchFilterOption prop format", searchFilterSelectedOption);
                    }
                    this.setSearchFilterSelectedOptionFilteredItemsIdsFor(searchFilterSelectedOption);
                }
                break;

            case RESOURCE_GROUP_TYPES.ASSET:

                if (this.props.assetsSearchFilterOption) {
                    const {searchFilterSelectedOption} = this.props.assetsSearchFilterOption;
                    
                    const labelAndValue = searchFilterSelectedOption.value || searchFilterSelectedOption.label;
                    
                    this.searchFilterInputValueApplyThrottledStateValue = labelAndValue;
                    
                    this.preFilteredResourcesVisibilityById = this.props.preFilteredAssetsVisibilityById;

                    if (labelAndValue) {
                        // restore input box state for search filter
                        this.setState({
                            searchFilterInputValue: labelAndValue
                        });
                    } else {
                        console.error("ResourceGroup componentDidMount invalid assetsSearchFilterOption prop format", this.props.assetsSearchFilterOption);
                    }
                    this.setSearchFilterSelectedOptionFilteredItemsIdsFor(searchFilterSelectedOption);
                }
                break;

            default:
                break;
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onListScroll);
        if (this.scrollMonitorIntervalID) clearInterval(this.scrollMonitorIntervalID);
        if (this.scrollMonitorIntervalTimeoutID) clearTimeout(this.scrollMonitorIntervalTimeoutID);
    }

    componentDidUpdate (prevProps) {

        // ResourceGroup is a pure component. Comparing prevProps to props is unnecessary

        // loop through children with DASHBOARD_RESOURCE_ITEM_HEIGHT:
        // * count
        this.onListScroll();
    }

    reactSelectClearFilter = (filterType) => {

        // If filterType is NOT provided, it means user has clicked on the 'Clear' button, so we need to clear both filters and restore the original state of the resources
        // BUT If filterType is provided, we only clear that filter, and ONLY proceed to restore the original state of the resources if the other filter is also cleared/not used

        if(!filterType || filterType === 'search'){

            this.setState({
                searchFilterInputValue: "",
            });
            
            this.searchFilterInputValueApplyThrottledStateValue = undefined; // IMPORTANT: `undefined` is used for determining if a search has started from scratch
            
            // pave the way for an instant update (clear interval)
            clearTimeout(this.searchFilterInputValueApplyThrottledTimeoutId);
            this.searchFilterInputValueApplyThrottledTimeoutId = undefined;

            
            // apply instantly
            this.searchFilterInputValueApplyDate = new Date();

            const tagsFilterIsActive = this.filterByTagsSelectedOptionsStateValue.length > 0;

            if(filterType && tagsFilterIsActive) return;
        }

        if(!filterType || filterType === 'tags'){

            this.filterByTagsSelectedOptionsStateValue = [];

            this.setState({
                filterByTagsSelectedOptions: []
            });

            const searchFilterIsCleared = this.searchFilterInputValueApplyThrottledStateValue === "" ||
            this.searchFilterInputValueApplyThrottledStateValue === undefined;

            if(filterType && !searchFilterIsCleared) return;
        }

        // Reaching here means both Search filter and Tags filter are cleared
        // So we can clear the filtering result and restore the original state of the resources
        this.setState({
            searchFilterSelectedOptionFilteredItemsIds: null,
            searchFilterInputValueShowNoResultsMessage: false
        });

        switch (this.props.type) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
                this.props.setRavensSearchFilterOption(null);
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                this.props.setGeofencesSearchFilterOption(null);
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                this.props.setAssetsSearchFilterOption(null);
                break;
            default:
                break;
        }

        this.restorePreFilteredResourcesVisibilityById(); // restore state and reset the preFilteredResourcesVisibilityById property
    }

    setPreFilteredResourcesVisibilityById = () => {

        if (this.searchFilterInputValueApplyThrottledStateValue !== undefined || // search filter is active
            this.filterByTagsSelectedOptionsStateValue.length > 0 // tags filter is active
        ) {
            return; // not pre-filtered
        }

        let visibleStateById = {};
        switch (this.props.type) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
                this.props.items.forEach( (item) => {
                    visibleStateById[item.ravenUuid] = !item.hidden; // setting as "visible" (negating 'hidden')
                });
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                this.props.items.forEach( (itemId) => {
                    visibleStateById[itemId] = this.props.geofenceVisibilityForId(itemId);
                });
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                this.props.items.forEach( (itemId) => {
                    visibleStateById[itemId] = this.props.assetVisibilityForId(itemId);
                });
                break;
            default:
                return;
        }
        this.preFilteredResourcesVisibilityById = visibleStateById;
    }

    restorePreFilteredResourcesVisibilityById = () => {

        const ids = Object.keys(this.preFilteredResourcesVisibilityById);

        if (ids.length > 0) {
            ids.forEach( (resourceId) => {
                this.props.setVisible(resourceId, this.preFilteredResourcesVisibilityById[resourceId]);
            });
        } else { // failsafe: set all visible (a basic clear filter behaviour)
            this.props.setAllVisible(this.props.type, true);
        }

    }

    onSelectResource = (resourceType, resourceId, visible) => {
        // if filtering is active, update preFilteredResourcesVisibilityById
        if (this.state.searchFilterInputValue ||  // search filter is active
            this.filterByTagsSelectedOptionsStateValue.length > 0 // tags filter is active
        ) { 
            this.preFilteredResourcesVisibilityById[resourceId] = visible; // allows subcomponents (itemFactory) resource tap events to update filtered items, to set their visibility for when filter is cleared
        }
        this.props.onSelectResource(resourceType, resourceId);
    }

    setSearchFilterSelectedOptionFilteredItemsIdsFor = (searchFilterSelectedOption, filterByTagsSelectedOptions) => {
        let value = null;
        let searchFilterInputValueShowNoResultsMessage = false;

        if (searchFilterSelectedOption) {
            value = searchFilterSelectedOption.value;
        }
        if (value) {
            value = value.toLowerCase();
        }

        const matchingItemIds = [];

        searchFilterSelectedOption.label = value;

        switch (this.props.type) {

            case RESOURCE_GROUP_TYPES.VEHICLE:
                this.props.items.forEach( (raven) => {
                    const matchesTheSearchFilter = this.matchAgainstSearchFilter(raven, this.props.type, value);
                    const matchesTheTagsFilter = this.matchAgainstSelectedTags(raven, filterByTagsSelectedOptions);
                    
                    if (matchesTheSearchFilter && matchesTheTagsFilter) {
                        matchingItemIds.push(raven.ravenUuid);
                        this.props.setVisible(raven.ravenUuid, true);
                    } else {
                        this.props.setVisible(raven.ravenUuid, false);
                    }
                });
                break;

            case RESOURCE_GROUP_TYPES.GEOFENCE:

                this.props.items.forEach( (geofenceId) => {
                    const matchesTheSearchFilter = this.matchAgainstSearchFilter(geofenceId, this.props.type, value);
                    if (matchesTheSearchFilter) {
                        matchingItemIds.push(geofenceId);
                        this.props.setVisible(geofenceId, true);
                    } else {
                        this.props.setVisible(geofenceId, false);
                    }
                });
                break;

            case RESOURCE_GROUP_TYPES.ASSET:

                this.props.items.forEach( (assetId) => {
                    const assetName = this.props.assetNameForId(assetId);
                    if (assetName) {
                        if (assetName.toLowerCase().includes(value)) {
                            matchingItemIds.push(assetId);
                            this.props.setVisible(assetId, true);
                        } else {
                            this.props.setVisible(assetId, false);
                        }
                    }
                });
                break;

            default:
                break;
        }

        if (matchingItemIds.length === 0) {
            if (value !== null || filterByTagsSelectedOptions.length > 0) { // check if a filter value was used
                searchFilterInputValueShowNoResultsMessage = true;
            }
        } else if (this.props.selectedResource && this.props.selectedResource.resourceType === this.props.type) {
            /* Auto-select conflicts with RAV-3515 and is starting to seem counterintuitive (plus, some team member feedback includes toning auto-select down to only the last item or removing it entirely anyway)
            if (!matchingItemIds.includes(this.props.selectedResource.resourceId)) {
                // auto-select the first filtered option
                this.props.onSelectResource(this.props.selectedResource.resourceType, matchingItemIds[0]);
            }*/
        }
        this.setState({
            searchFilterSelectedOptionFilteredItemsIds: matchingItemIds,
            searchFilterInputValueShowNoResultsMessage: searchFilterInputValueShowNoResultsMessage
        });
    }

    applyInputAsReactSelectOption = () => {
        if (this.searchFilterInputValueApplyThrottledStateValue === "" ||        //     user has deleted their entry 
            this.searchFilterInputValueApplyThrottledStateValue === undefined) {  // OR  user has hit enter prior to typing a characters 
                this.reactSelectClearFilter('search');
        } else {
            this.reactSelectOnChangeHandler();
        }
    }

    applySelectedTagsAsReactSelectOption = () => {
        const tagsAreSelected  = this.filterByTagsSelectedOptionsStateValue.length > 0;

        if (!tagsAreSelected) {  // no tags are selected to filter by
            this.reactSelectClearFilter('tags');
        } else {
            this.reactSelectOnChangeHandler();
        }
    }

    searchFilterInputFormSubmitHandler = (event) => {
        event.preventDefault();
        const applyImmediately = true;
        this.searchFilterInputValueChangeHandler({target: event.target.firstChild}, applyImmediately);
    }

    searchFilterInputValueChangeHandler = (event, applyImmediately = false) => {

        this.setPreFilteredResourcesVisibilityById();

        // update the ui instantly for the input
        this.setState({
            searchFilterInputValue: event.target.value
        });

        // throttle apply the filter
        this.searchFilterInputValueApplyThrottledStateValue = event.target.value;

        const now = new Date();
        const milliscondsSinceLastApply = now - this.searchFilterInputValueApplyDate;

        clearTimeout(this.searchFilterInputValueApplyThrottledTimeoutId);
        if ((milliscondsSinceLastApply >= SEARCH_FILTER_INPUT_VALUE_APPLY_INTERVAL) ||
            applyImmediately) {
            // apply immediately
            this.applyInputAsReactSelectOption();
            this.searchFilterInputValueApplyDate = now;
            return;
        }

        this.searchFilterInputValueApplyThrottledTimeoutId = setTimeout( () => {
            this.applyInputAsReactSelectOption();
            this.searchFilterInputValueApplyDate = now;
        }, SEARCH_FILTER_INPUT_VALUE_APPLY_INTERVAL);
    }

    reactSelectOnChangeHandler = () => {
        
        const labelAndValue = this.searchFilterInputValueApplyThrottledStateValue;

        const searchFilterSelectedOption = {label: labelAndValue, value: labelAndValue};
        const filterByTagsSelectedOptions = this.filterByTagsSelectedOptionsStateValue;

        this.setSearchFilterSelectedOptionFilteredItemsIdsFor(searchFilterSelectedOption, filterByTagsSelectedOptions);

        switch (this.props.type) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
                this.props.setRavensSearchFilterOption({searchFilterSelectedOption, filterByTagsSelectedOptions}, this.preFilteredResourcesVisibilityById); // update sessionManager state's copy to restore across mount/unmounts
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                this.props.setGeofencesSearchFilterOption({searchFilterSelectedOption}, this.preFilteredResourcesVisibilityById); // update sessionManager state's copy to restore across mount/unmounts
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                this.props.setAssetsSearchFilterOption({searchFilterSelectedOption}, this.preFilteredResourcesVisibilityById);
                break;
            default:
                break;
        }
    };

    renderNoResourcesMessage = () => {
        const resourceTypes = [RESOURCE_GROUP_TYPES.ASSET, RESOURCE_GROUP_TYPES.GEOFENCE]
        
        if(!resourceTypes.includes(this.props.type)) return null;

        const resourceTypeTitle = strings[`resource_group_title_${this.props.type.toLowerCase()}s`];
        const noResourcesMessage = strings.formatString(strings.resource_group_no_resources_msg, resourceTypeTitle);
        return (            
            <li className="resource-group-filter-applied-no-results-message">
               {noResourcesMessage}
            </li>
        );
    }

    onFilterByTagsChange = (selectedTagsIds) => {
        
        this.setPreFilteredResourcesVisibilityById();

        this.filterByTagsSelectedOptionsStateValue = selectedTagsIds;
        
        this.setState({ filterByTagsSelectedOptions : selectedTagsIds });

        this.applySelectedTagsAsReactSelectOption();
    }

    matchAgainstSelectedTags = (item, filterByTagsSelectedOptions) => {
        if(filterByTagsSelectedOptions.length === 0) return true;

        return item.tags && item.tags.some(tag => filterByTagsSelectedOptions.includes(tag.tagId));
    }

    matchAgainstSearchFilter = (item, itemsType, keyword) => {

        if(keyword === undefined || keyword === "") return true;

        switch (itemsType) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
                    return item.vehicle && 
                           item.vehicle.name && 
                           item.vehicle.name.toLowerCase().includes(keyword);

            case RESOURCE_GROUP_TYPES.GEOFENCE:
                const geofenceName = this.props.geofenceNameForId(item);
                return geofenceName && geofenceName.toLowerCase().includes(keyword);
        }
    }

    setFilterByTagsOptions = () => {
        this.setState({ filterByTagsSelectedOptions: this.filterByTagsSelectedOptionsStateValue });
    }

    setAllVisible = (visibility) => {
        this.setState({
            setAllVisible: visibility
        });
        this.props.setAllVisible(this.props.type, visibility);
    }

    toggleBadgesView = (event) => {
        this.setState({
            currentBadgesView: event.target.id.split('-')[0]
        });
    }

    renderTagsFilter = () => {
        // There is no error, no loading and no loaded tags. So, can conclude Tags are not enabled.
        const tagsNotEnabled = !this.props.tagsLoaded && !this.props.tagsLoading && !this.props.tagsError;

        if(tagsNotEnabled){
            console.log('ResourceGroup: Tags are not enabled');
            return null;
        }

        if(this.props.tagsError){
            console.error('ResourceGroup: Error fetching tags');
            return null;
        }

        if(this.props.tagsLoading){
            return (<header className="resource-group-header">
                        <div className="loading-tags"><ProgressSpinnerSmall/><div></div></div>
                    </header>);
        }

        if(this.props.tags.length === 0){
            return null;
        }

        return (
            <header className="resource-group-header">
                <TagsTreeViewDropDown
                    tags={this.props.tags}
                    selectedTagsIds={this.state.filterByTagsSelectedOptions}
                    placeholder={strings.tags_filter_by_tags}
                    multipleSelection={true}
                    onChange={this.onFilterByTagsChange}
                    className="resource-group-header-filter"
                    compact
                />
            </header>
        );

    }

    render() {

        const {
            type,
            collapsed,
            itemFactory,
            setAllVisible,
            footer,
            footerHeight,
            selectedResource,
            loading,
            ...itemProps
        } = this.props;

        let renderEmptyList = this.props.renderEmptyList;

        let items = this.props.items;

        if (this.state.searchFilterSelectedOptionFilteredItemsIds) {

            switch (this.props.type) {

                case RESOURCE_GROUP_TYPES.VEHICLE:
                    items = items.filter((item) => {
                        return this.state.searchFilterSelectedOptionFilteredItemsIds.includes(item.ravenUuid);
                    });                                
                    break;

                case RESOURCE_GROUP_TYPES.GEOFENCE:
                    items = items.filter((itemId) => {
                        return this.state.searchFilterSelectedOptionFilteredItemsIds.includes(itemId);
                    });
                    break;

                case RESOURCE_GROUP_TYPES.ASSET:
                    items = items.filter((itemId) => {
                        return this.state.searchFilterSelectedOptionFilteredItemsIds.includes(itemId);
                    });
                    break;

                default:
                    break;
            }

            if (items.length === 0) {
                renderEmptyList = true;
            }
        }


        if (!items) return null
        if (!renderEmptyList && !items.length) return null;

        let resourceGroupClasses = [
            "resource-group",
            type,
        ];

        resourceGroupClasses.push("alert_level " + this.highestAlertLevelForGroup);

        if (collapsed) {
            resourceGroupClasses.push('collapsed');
        }

        if (type === RESOURCE_GROUP_TYPES.VEHICLE && this.props.selectedRavenUuid) {
            itemProps.selectedId = this.props.selectedRavenUuid;
        } else if (selectedResource && selectedResource.resourceType === type) {
            itemProps.selectedId = selectedResource.resourceId;
        }

        this.prepareGroupWarningAndItemElementsArray(items, itemProps, itemFactory);

        let searchFilterOptionActiveForCurrentType = false;
        switch (this.props.type) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
                if (this.props.ravensSearchFilterOption) {
                    searchFilterOptionActiveForCurrentType = true;
                }
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                if (this.props.geofencesSearchFilterOption) {
                    searchFilterOptionActiveForCurrentType = true;
                }
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                if (this.props.assetsSearchFilterOption) {
                    searchFilterOptionActiveForCurrentType = true;
                }
                break;
            default:
                break;
        }

        return (
            <section className={resourceGroupClasses.join(" ")} style={{"maxHeight" : this.resourceGroupSectionHeight() + "px"}} >
                <ResizeThrottler interval={300} callback={this.setWarningBadgesStateForRenderedElements} />
                { ((items && items.length > 0) || (this.state.searchFilterInputValueShowNoResultsMessage)) ? // caution: this.props.type === RESOURCE_GROUP_TYPES.VEHICLE is essentially assumed for NoResultsMessage
                    <>
                    <header className="resource-group-header">
                        <form onSubmit={this.searchFilterInputFormSubmitHandler}>
                            <input
                                type="text"
                                className="resource-group-search-filter"
                                placeholder={strings.db_search_ellipses}
                                value={this.state.searchFilterInputValue}
                                onChange={this.searchFilterInputValueChangeHandler}
                            />
                        </form>
                    </header>
                    {/* Filter by tags currently only for ravens/vehicles */}
                    {this.props.type === RESOURCE_GROUP_TYPES.VEHICLE &&
                        this.renderTagsFilter()
                    }
                    <header className={this.props.type === RESOURCE_GROUP_TYPES.VEHICLE ? "resource-group-header resource-group-controls resource-group-controls-extended" : "resource-group-header resource-group-controls"}>
                        
                            {searchFilterOptionActiveForCurrentType ?
                                <div className="resource-group-clear-search-filter">
                                    <button className="btn btn-blue btn-sm" onClick={() => this.reactSelectClearFilter()}>{strings.formatString(strings.db_clear_filter)}</button>
                                </div>
                            :
                                <div className="resource-group-toggle-visibility">
                                    <button disabled={searchFilterOptionActiveForCurrentType} className="btn btn-blue btn-sm" onClick={() => setAllVisible(type, true)}>{strings.formatString(strings.db_ravens_sel_all)}</button>
                                    <button disabled={searchFilterOptionActiveForCurrentType} className="btn btn-blue btn-sm" onClick={() => setAllVisible(type, false)}>{strings.formatString(strings.db_ravens_sel_none)}</button>
                                </div>
                            }
                        {/* Switch between tags/status badges currently only for ravens/vehicles */}
                        {this.props.type === RESOURCE_GROUP_TYPES.VEHICLE &&
                            <div className="resource-badges-switch">
                                <label className={this.state.currentBadgesView === 'tags' ? "resource-badge resource-badge-tags active" : "resource-badge resource-badge-tags"} >
                                    <input type="radio" name="badgesViews" id="tags-view" autoComplete="off" onChange={this.toggleBadgesView} checked={this.state.currentBadgesView === 'tags'} />
                                    <div><i className='material-icons'>sell</i>{strings.tags_label}</div>
                                </label>
                                <label  className={this.state.currentBadgesView === 'status' ? "resource-badge resource-badge-status active" : "resource-badge resource-badge-status"}>
                                    <input type="radio" name="badgesViews" id="status-view" autoComplete="off" onChange={this.toggleBadgesView} checked={this.state.currentBadgesView === 'status'} />
                                    <div><i className='material-icons'>info_outline</i>{strings.status_label}</div>
                                </label>

                            </div>
                        }
                    </header>
                    </>
                :
                    null
                }

                {(this.props.listErrorMessage || this.state.itemErrorMessage) &&
                    <header className="resource-group-header resource-group-header-error">
                        <div className="error-message">
                            {this.props.listErrorMessage || this.state.itemErrorMessage}
                        </div>
                    </header>
                }

                {this.state.totalTopHiddenWarningItems ? <div className="warning-badge-container top"><div className="badge"><span>{this.state.totalTopHiddenWarningItems}</span></div></div> : null }
                <ul className="resources" ref={this.groupListRef} onScroll={this.onListScroll}>
                {this.state.searchFilterInputValueShowNoResultsMessage ?
                    <div className="resource-group-filter-applied-no-results-message">
                        {strings.db_filter_no_matches_found}
                    </div>
                :
                    this.showNoResourcesMessage ? 
                    this.renderNoResourcesMessage() // Show a message when there are no Assets or Geofences.
                    :
                    this.groupListItemsComponents.map(element => {return element;})
                }                    
                </ul>
                {(this.props.type === RESOURCE_GROUP_TYPES.VEHICLE) && this.state.searchFilterInputValueShowNoResultsMessage ?
                    null
                :
                    <>
                    {this.state.totalBottomHiddenWarningItems ? <div className="warning-badge-container bottom"><div className="badge"><span>{this.state.totalBottomHiddenWarningItems}</span></div></div> : null }
                    {this.state.totalWarningItems ? <div className="warning-badge-container header-when-collapsed"><div className="badge"><span>{this.state.totalWarningItems}</span></div></div> : null }
                    </>
                }
                {footer && <footer className="resource-group-footer">{footer}</footer>}
                {loading && <ProgressOverlay />}
            </section>
        );
    }

    toggleExpand = () => {
        this.props.toggleCollapsedForType(this.props.type);
    }
}

ResourceGroup.propTypes = {
    itemFactory: PropTypes.func.isRequired,
    items: PropTypes.array, // ravens, geofences, assets
    geofenceNameForId: PropTypes.func, // "items" for geofences is an array of ids only
    geofenceVisibilityForId: PropTypes.func, // "items" for geofences is an array of ids only
    assetNameForId: PropTypes.func, // "items" for assets is an array of ids only
    assetVisibilityForId: PropTypes.func, // "items" for assets is an array of ids only
    selection: PropTypes.object,
    features: PropTypes.object,
    changeVehicleName: PropTypes.func.isRequired,
    setAllVisible: PropTypes.func.isRequired,
    setVisible: PropTypes.func.isRequired,
    listErrorMessage: PropTypes.string, // error message for the entire list ,e.g. "Failed to load assets"
}
